var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:{ 'checked': _vm.isChecked },attrs:{"for":_vm.id}},[_c('input',{attrs:{"type":"radio","name":_vm.name,"id":_vm.id},domProps:{"value":_vm.id},on:{"click":_vm.selected}}),_vm._v(" "),_c('span',{class:{'radiobutton': _vm.isRadioButton}},[_vm._v(_vm._s(_vm.artName))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33365930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/Checkbox.vue
// module id = null
// module chunks = 